export default "__VITE_ASSET__BiTgfuiL__"